import { NavLink, useLocation } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'
import './Sidebar.css'

function Sidebar() {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()
  const overlayRef = useRef(null)

  useEffect(() => {
    // Cerrar sidebar cuando cambia la ruta
    setIsOpen(false)
  }, [location.pathname])

  useEffect(() => {
    // Bloquear scroll de la página cuando el sidebar está abierto en móvil
    if (isOpen && window.innerWidth <= 768) {
      const scrollY = window.scrollY ?? document.documentElement.scrollTop
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.top = `-${scrollY}px`
      document.body.style.left = '0'
      document.body.style.right = '0'
      document.body.dataset.sidebarScrollY = String(scrollY)
    } else {
      const savedScroll = document.body.dataset.sidebarScrollY
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.left = ''
      document.body.style.right = ''
      if (savedScroll !== undefined) {
        window.scrollTo(0, Number(savedScroll))
        delete document.body.dataset.sidebarScrollY
      }
    }
    return () => {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.left = ''
      document.body.style.right = ''
      const savedScroll = document.body.dataset.sidebarScrollY
      if (savedScroll !== undefined) {
        window.scrollTo(0, Number(savedScroll))
        delete document.body.dataset.sidebarScrollY
      }
    }
  }, [isOpen])

  // Evitar que el gesto de deslizar en el overlay haga scroll de la página detrás
  useEffect(() => {
    const overlay = overlayRef.current
    if (!overlay) return
    const preventScroll = (e) => {
      if (isOpen) e.preventDefault()
    }
    overlay.addEventListener('touchmove', preventScroll, { passive: false })
    return () => overlay.removeEventListener('touchmove', preventScroll)
  }, [isOpen])

  return (
    <>
      <button 
        className="sidebar-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle sidebar"
      >
        <span className={`sidebar-toggle-icon ${isOpen ? 'active' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
      
      <div 
        ref={overlayRef}
        className={`sidebar-overlay ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(false)}
        role="button"
        tabIndex={-1}
        aria-label="Close menu"
      />
      
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <nav className="sidebar-nav">
        <NavLink 
          to="/dashboard" 
          end
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          Dashboard
        </NavLink>
        
        <NavLink 
          to="/dashboard/checklist" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          Checklist
        </NavLink>
        
        <NavLink 
          to="/dashboard/budget-manager" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          Budget Manager
        </NavLink>
        
        <NavLink 
          to="/dashboard/timeline-creator" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          Timeline Creator
        </NavLink>
        
        <div className="nav-section">
          <div className="nav-section-title">GUEST MANAGER</div>
          <NavLink 
            to="/dashboard/guest-manager" 
            end
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            Guest List
          </NavLink>
          <NavLink 
            to="/dashboard/guest-manager/the-lifesaver-link" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            The Lifesaver Link
          </NavLink>
          <NavLink 
            to="/dashboard/guest-manager/craft-your-invite" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            Craft Your Invite
          </NavLink>
          <NavLink 
            to="/dashboard/guest-manager/gentle-reminder-time" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            Gentle Reminder Time
          </NavLink>
          <NavLink 
            to="/dashboard/guest-manager/who-sits-where" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            Who Sits Where
          </NavLink>
        </div>
        
        <div className="nav-section">
          <div className="nav-section-title">SUPPLIER MANAGER</div>
          <NavLink 
            to="/dashboard/supplier-manager" 
            end
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            Dashboard
          </NavLink>
          <NavLink 
            to="/dashboard/supplier-manager/numbers-please" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            Numbers please
          </NavLink>
          <NavLink 
            to="/dashboard/supplier-manager/the-chosen-ones" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            The chosen ones
          </NavLink>
        </div>
        
        <div className="nav-section">
          <div className="nav-section-title">LISTS</div>
          <NavLink 
            to="/dashboard/lists/must-capture-moments" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            Must-Capture Moments
          </NavLink>
          <NavLink 
            to="/dashboard/lists/the-soundtrack" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            The Soundtrack
          </NavLink>
          <NavLink 
            to="/dashboard/lists/bloom-board" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            Bloom Board
          </NavLink>
          <NavLink 
            to="/dashboard/lists/wedding-cargo" 
            className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`}
          >
            Wedding Cargo
          </NavLink>
        </div>
        
        {/* Newsletter - Hidden, will be activated later */}
        {/* <NavLink 
          to="/dashboard/newsletter" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          Newsletter
        </NavLink> */}
      </nav>
    </aside>
    </>
  )
}

export default Sidebar
